(function () {
  'use strict';

  var root = document.getElementById('pcbf-root');
  if (!root) return;

  // App-tuned styles for the stacked build-result cards. Injected once so the
  // whole redesign lives in this app copy — the shared pcbf.css is untouched.
  // Colors inherit the store accent via --pcbf-accent (defined in pcbf.css).
  (function injectStappStyles() {
    if (document.getElementById('stapp-build-styles')) return;
    var css =
      '.stapp-build-card{background:#fff;border:1px solid #e9ecf3;border-radius:16px;padding:14px;margin-bottom:16px}' +
      '.stapp-build-tabs{display:flex;background:#eef0f6;border-radius:12px;padding:4px;gap:4px;margin-bottom:12px}' +
      '.stapp-build-tab{flex:1;height:38px;border:0;background:transparent;border-radius:9px;font-size:13px;font-weight:600;color:#6b7280;cursor:pointer}' +
      '.stapp-build-tab.active{background:#fff;color:var(--pcbf-accent,#3b47e0);font-weight:700;box-shadow:0 1px 3px rgba(16,19,34,.12)}' +
      '.stapp-build-head h4{margin:0;font-size:17px;font-weight:800;color:#101322}' +
      '.stapp-build-sub{font-size:11.5px;color:#6b7280}' +
      '.stapp-build-total-row{display:flex;align-items:baseline;justify-content:space-between;gap:10px;margin:8px 0 12px}' +
      '.stapp-total-amount{font-size:22px;font-weight:800;color:#101322}' +
      '.stapp-build-total-row .note{font-size:12px;font-weight:600}' +
      '.stapp-build-total-row .note.ok{color:#0a8a4a}.stapp-build-total-row .note.warn{color:#c0392b}' +
      '.stapp-parts{display:flex;flex-direction:column;gap:8px}' +
      '.stapp-part{position:relative;display:flex;align-items:center;gap:11px;background:#fff;border:1px solid #e9ecf3;border-radius:14px;padding:11px 12px}' +
      '.stapp-part-thumb{width:46px;height:46px;border-radius:10px;object-fit:cover;background:#f0f2f8;flex-shrink:0}' +
      '.stapp-part-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}' +
      '.stapp-part-cat{font-size:9.5px;font-weight:700;letter-spacing:1px;color:#8a91a0}' +
      '.stapp-part-name{font-size:13px;font-weight:700;color:#1a2032;line-height:1.3}' +
      '.stapp-part-change{font-size:11px;font-weight:600;color:var(--pcbf-accent,#3b47e0)}' +
      '.stapp-part-price{font-size:13px;font-weight:800;color:#101322;white-space:nowrap}' +
      '.stapp-part-chev{color:#c2c8d6;flex-shrink:0}' +
      '.stapp-part-overlay{position:absolute;inset:0;width:100%;height:100%;opacity:0;border:0;margin:0;padding:0;-webkit-appearance:none;appearance:none;cursor:pointer}' +
      '.stapp-build-actions{display:flex;flex-direction:column;gap:9px;margin-top:14px}' +
      '.stapp-btn{width:100%;border:0;border-radius:13px;font-size:15px;font-weight:700;padding:15px 12px;cursor:pointer}' +
      '.stapp-btn-buy{background:var(--pcbf-accent,#3b47e0);color:#fff}' +
      '.stapp-btn-whatsapp{background:#fff;color:#3a4152;border:1.5px solid #e1e5ef;font-size:13.5px;padding:12px}' +
      '.stapp-part--oos{border-color:#e5484d;background:#fff6f6;box-shadow:inset 0 0 0 1px #e5484d}' +
      '.stapp-part-oos-badge{display:inline-block;margin-left:6px;background:#e5484d;color:#fff;font-size:8.5px;font-weight:800;letter-spacing:.6px;padding:1px 5px;border-radius:5px;vertical-align:middle}';
    var el = document.createElement('style');
    el.id = 'stapp-build-styles';
    el.textContent = css;
    document.head.appendChild(el);
  })();

  var CATALOG = JSON.parse(document.getElementById('pcbf-catalog').textContent);
  var WHATSAPP_NUMBER = root.dataset.whatsapp || '';
  var CURRENCY = root.dataset.currency || '₹';

  var PICKUP_ENABLED = root.dataset.pickupEnabled === 'true';
  var PICKUP_MESSAGE = root.dataset.pickupMessage || '';
  var DELIVERY_MESSAGE = root.dataset.deliveryMessage || '';

  var EMI_ENABLED = root.dataset.emiEnabled === 'true';
  var EMI_NO_COST_TENURES = (root.dataset.emiNoCostTenures || '')
    .split(',').map(function (s) { return parseInt(s.trim(), 10); }).filter(Boolean);
  var EMI_INTEREST_TENURES = (root.dataset.emiInterestTenures || '')
    .split(',').map(function (s) { return parseInt(s.trim(), 10); }).filter(Boolean);
  var EMI_ANNUAL_RATE = parseFloat(root.dataset.emiInterestRate) || 0;

  var form = document.getElementById('pcbf-form');
  var useField = document.getElementById('pcbf-use');
  var targetField = document.getElementById('pcbf-target-field');
  var gpuBrandSelect = document.getElementById('pcbf-gpu-brand');
  var monitorBrandSelect = document.getElementById('pcbf-monitor-brand');
  var intro = document.getElementById('pcbf-intro');
  var results = document.getElementById('pcbf-results');

  // -------------------- weighting profiles --------------------
  var CORE_CATEGORIES = ['processor', 'motherboard', 'ram', 'gpu', 'storage', 'psu', 'case', 'cooler'];
  var LABELS = {
    processor: 'Processor', motherboard: 'Motherboard', ram: 'Memory', gpu: 'Graphics card',
    storage: 'Storage', psu: 'Power supply', case: 'Cabinet', cooler: 'CPU cooler',
    monitor: 'Monitor', keyboard: 'Keyboard', mouse: 'Mouse', headset: 'Headset'
  };
  var WEIGHTS = {
    gaming:    { gpu: .36, processor: .19, motherboard: .10, ram: .09, storage: .07, psu: .07, case: .06, cooler: .06 },
    editing:   { processor: .28, gpu: .20, motherboard: .10, ram: .14, storage: .10, psu: .07, case: .05, cooler: .06 },
    office:    { processor: .24, gpu: .08, motherboard: .14, ram: .14, storage: .14, psu: .10, case: .08, cooler: .08 },
    streaming: { processor: .26, gpu: .24, motherboard: .10, ram: .12, storage: .08, psu: .08, case: .06, cooler: .06 }
  };
  var MONITOR_RESERVE = 0.09;
  var PERIPHERALS_RESERVE = 0.05; // split across keyboard/mouse/headset
  var DOWNGRADE_ORDER = ['headset', 'mouse', 'keyboard', 'monitor', 'case', 'cooler', 'storage', 'psu', 'gpu'];

  // -------------------- helpers --------------------
  function money(n) {
    return CURRENCY + Math.round(n).toLocaleString('en-IN');
  }
  function norm(s) { return (s || '').toString().trim().toLowerCase(); }

  // StoreToApp: true when running inside the mobile app's experience
  // container (storetoapp.js SDK loaded and the native bridge is present)
  function inApp() {
    return !!(window.StoreToApp && window.StoreToApp.isApp);
  }

  function byVendor(list, vendor) {
    if (!vendor) return list;
    return list.filter(function (p) { return norm(p.vendor) === norm(vendor); });
  }

  function platformVendors(platform) {
    if (platform === 'amd') return ['amd'];
    if (platform === 'intel') return ['intel'];
    return null; // both
  }

  // pick a good-fit item near target, with randomness so repeated searches
  // using the same inputs don't always return the identical build
  function pickBest(candidates, target) {
    var avail = candidates.filter(function (p) { return p.available !== false; });
    if (!avail.length) avail = candidates;
    if (!avail.length) return null;
    var sorted = avail.slice().sort(function (a, b) { return a.price - b.price; });
    var ceiling = target * 1.2;
    var inRange = sorted.filter(function (p) { return p.price <= ceiling; });
    if (!inRange.length) return sorted[0]; // nothing fits near target — cheapest overall

    // shortlist: candidates reasonably close to target price, so a random
    // pick still stays sensible instead of jumping to something far cheaper
    var floor = target * 0.65;
    var shortlist = inRange.filter(function (p) { return p.price >= floor; });
    if (!shortlist.length) shortlist = inRange.slice(-Math.min(3, inRange.length));
    return shortlist[Math.floor(Math.random() * shortlist.length)];
  }

  function pickCheapest(candidates) {
    var avail = candidates.filter(function (p) { return p.available !== false; });
    if (!avail.length) avail = candidates;
    if (!avail.length) return null;
    return candidates.slice().sort(function (a, b) { return a.price - b.price; })[0];
  }

  function compatibleMotherboards(processor) {
    if (!processor) return CATALOG.motherboard;
    var matches = CATALOG.motherboard.filter(function (m) { return norm(m.socket) === norm(processor.socket) && norm(m.socket) !== ''; });
    return matches.length ? matches : CATALOG.motherboard;
  }
  function compatibleRam(motherboard) {
    if (!motherboard) return CATALOG.ram;
    var matches = CATALOG.ram.filter(function (r) { return norm(r.memory_type) === norm(motherboard.memory_type) && norm(r.memory_type) !== ''; });
    return matches.length ? matches : CATALOG.ram;
  }

  // -------------------- core build assembly --------------------
  function buildForPlatform(platform, params) {
    var vendors = platformVendors(platform);
    var cpuPool = vendors ? byVendor(CATALOG.processor, vendors[0]) : CATALOG.processor;
    if (!cpuPool.length) return null;

    var weights = WEIGHTS[params.primaryUse] || WEIGHTS.gaming;
    var peripheralsReserve = 0;
    if (params.includeMonitor) peripheralsReserve += MONITOR_RESERVE;
    if (params.includePeripherals) peripheralsReserve += PERIPHERALS_RESERVE;
    var coreBudget = params.budget * (1 - peripheralsReserve);

    var picks = {};
    var compatIssue = false;

    // processor
    picks.processor = pickBest(cpuPool, coreBudget * weights.processor);
    // motherboard (compat-filtered)
    var mbPool = compatibleMotherboards(picks.processor);
    if (picks.processor && mbPool === CATALOG.motherboard && CATALOG.motherboard.length) compatIssue = true;
    picks.motherboard = pickBest(mbPool, coreBudget * weights.motherboard);
    // ram (compat-filtered against motherboard)
    var ramPool = compatibleRam(picks.motherboard);
    if (picks.motherboard && ramPool === CATALOG.ram && CATALOG.ram.length) compatIssue = true;
    picks.ram = pickBest(ramPool, coreBudget * weights.ram);

    // independent categories
    var gpuPool = byVendor(CATALOG.gpu, params.gpuBrand);
    picks.gpu = pickBest(gpuPool.length ? gpuPool : CATALOG.gpu, coreBudget * weights.gpu);
    picks.storage = pickBest(CATALOG.storage, coreBudget * weights.storage);
    picks.psu = pickBest(CATALOG.psu, coreBudget * weights.psu);
    picks.case = pickBest(CATALOG.case, coreBudget * weights.case);
    picks.cooler = pickBest(CATALOG.cooler, coreBudget * weights.cooler);

    if (params.includeMonitor) {
      var monPool = byVendor(CATALOG.monitor, params.monitorBrand);
      picks.monitor = pickBest(monPool.length ? monPool : CATALOG.monitor, params.budget * MONITOR_RESERVE);
    }
    if (params.includePeripherals) {
      picks.keyboard = pickBest(CATALOG.keyboard, params.budget * PERIPHERALS_RESERVE * 0.35);
      picks.mouse = pickBest(CATALOG.mouse, params.budget * PERIPHERALS_RESERVE * 0.30);
      picks.headset = pickBest(CATALOG.headset, params.budget * PERIPHERALS_RESERVE * 0.35);
    }

    // downgrade loop over independent, non-compatibility-locked categories
    var guard = 0;
    while (total(picks) > params.budget && guard < 40) {
      guard++;
      var downgraded = false;
      for (var i = 0; i < DOWNGRADE_ORDER.length; i++) {
        var cat = DOWNGRADE_ORDER[i];
        var current = picks[cat];
        if (!current) continue;
        var pool = poolFor(cat, params);
        var cheaper = pool.filter(function (p) { return p.price < current.price && p.available !== false; })
                          .sort(function (a, b) { return b.price - a.price; })[0];
        if (cheaper) { picks[cat] = cheaper; downgraded = true; break; }
      }
      if (!downgraded) break;
    }

    var finalTotal = total(picks);
    return {
      platform: platform,
      picks: picks,
      total: finalTotal,
      overBudget: finalTotal > params.budget ? finalTotal - params.budget : 0,
      compatIssue: compatIssue
    };
  }

  function poolFor(cat, params) {
    switch (cat) {
      case 'gpu': var g = byVendor(CATALOG.gpu, params.gpuBrand); return g.length ? g : CATALOG.gpu;
      case 'storage': return CATALOG.storage;
      case 'psu': return CATALOG.psu;
      case 'case': return CATALOG.case;
      case 'cooler': return CATALOG.cooler;
      case 'monitor': var m = byVendor(CATALOG.monitor, params.monitorBrand); return m.length ? m : CATALOG.monitor;
      case 'keyboard': return CATALOG.keyboard;
      case 'mouse': return CATALOG.mouse;
      case 'headset': return CATALOG.headset;
      default: return [];
    }
  }

  // -------------------- EMI --------------------
  function noCostEmi(amount, months) {
    return amount / months;
  }
  function interestEmi(amount, months, annualRatePercent) {
    var r = (annualRatePercent / 100) / 12;
    if (r === 0) return amount / months;
    var factor = Math.pow(1 + r, months);
    var monthly = amount * r * factor / (factor - 1);
    return monthly;
  }
  function emiRows(amount) {
    var rows = [];
    EMI_NO_COST_TENURES.forEach(function (m) {
      rows.push({ months: m, monthly: noCostEmi(amount, m), noCost: true });
    });
    EMI_INTEREST_TENURES.forEach(function (m) {
      var monthly = interestEmi(amount, m, EMI_ANNUAL_RATE);
      var totalInterest = (monthly * m) - amount;
      rows.push({ months: m, monthly: monthly, noCost: false, extraInterest: totalInterest });
    });
    rows.sort(function (a, b) { return a.months - b.months; });
    return rows;
  }
  function renderEmi(amount) {
    if (!EMI_ENABLED || amount <= 0) return '';
    var rows = emiRows(amount);
    if (!rows.length) return '';
    var body = rows.map(function (row) {
      var tag = row.noCost
        ? '<span class="pcbf-emi-tag">No cost</span>'
        : '<span class="pcbf-emi-tag interest">+' + money(row.extraInterest) + ' interest</span>';
      return (
        '<tr><td>' + row.months + ' months</td>' +
        '<td>' + money(row.monthly) + '/mo</td>' +
        '<td>' + tag + '</td></tr>'
      );
    }).join('');
    return (
      '<details class="pcbf-emi">' +
        '<summary>EMI options from ' + money(rows[0].monthly) + '/mo</summary>' +
        '<table class="pcbf-emi-table"><thead><tr><th>Tenure</th><th>Monthly</th><th></th></tr></thead>' +
        '<tbody>' + body + '</tbody></table>' +
        '<p class="pcbf-emi-note">Indicative figures — final EMI terms depend on your bank/card issuer.</p>' +
      '</details>'
    );
  }

  function renderFulfilment() {
    if (!PICKUP_ENABLED) return '';
    var parts = [];
    if (PICKUP_MESSAGE) parts.push('<span>🏬 ' + escapeHtml(PICKUP_MESSAGE) + '</span>');
    if (DELIVERY_MESSAGE) parts.push('<span>🚚 ' + escapeHtml(DELIVERY_MESSAGE) + '</span>');
    if (!parts.length) return '';
    return '<div class="pcbf-fulfilment">' + parts.join('') + '</div>';
  }

  function total(picks) {
    var sum = 0;
    Object.keys(picks).forEach(function (k) {
      if (picks[k]) sum += parseFloat(picks[k].price) || 0;
    });
    return sum;
  }

  // -------------------- rendering --------------------
  function candidatesFor(cat, build, params) {
    if (cat === 'processor') {
      var vendors = platformVendors(build.platform);
      var pool = vendors ? byVendor(CATALOG.processor, vendors[0]) : CATALOG.processor;
      return pool.length ? pool : CATALOG.processor;
    }
    if (cat === 'motherboard') return compatibleMotherboards(build.picks.processor);
    if (cat === 'ram') return compatibleRam(build.picks.motherboard);
    return poolFor(cat, params);
  }

  function renderBuild(build, params, hideHead) {
    var order = CORE_CATEGORIES.slice();
    if (params.includeMonitor) order.push('monitor');
    if (params.includePeripherals) order.push('keyboard', 'mouse', 'headset');

    // App-tuned layout: one stacked card per part instead of a 3-column table
    // (the table crushed the part name + swap control to ~23px on a phone).
    // Each card keeps the original <select class="pcbf-part-select"> as a
    // transparent full-card overlay, so the existing swap listener is unchanged.
    var rows = order.map(function (cat) {
      var pick = build.picks[cat];
      if (!pick) return '';
      var isOos = pick.available === false;
      var cands = candidatesFor(cat, build, params).slice().sort(function (a, b) { return a.price - b.price; });
      var options = cands.map(function (c) {
        var sel = c.id === pick.id ? ' selected' : '';
        var oos = c.available === false;
        return '<option value="' + c.id + '"' + sel + '>' + escapeHtml(c.title) + ' — ' + money(c.price) + (oos ? ' (Out of stock)' : '') + '</option>';
      }).join('');
      var thumb = pick.image
        ? '<img class="stapp-part-thumb" src="' + pick.image + '" alt="">'
        : '<div class="stapp-part-thumb stapp-part-thumb--ph"></div>';
      return (
        '<div class="stapp-part' + (isOos ? ' stapp-part--oos' : '') + '" data-cat="' + cat + '">' +
          thumb +
          '<div class="stapp-part-main">' +
            '<span class="stapp-part-cat">' + LABELS[cat] + (isOos ? '<span class="stapp-part-oos-badge">Out of stock</span>' : '') + '</span>' +
            '<span class="stapp-part-name">' + escapeHtml(pick.title) + '</span>' +
            '<span class="stapp-part-change">' + (isOos ? 'Tap to replace' : 'Tap to change') + '</span>' +
          '</div>' +
          '<span class="stapp-part-price">' + money(pick.price) + '</span>' +
          '<svg class="stapp-part-chev" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"></path></svg>' +
          '<select class="pcbf-part-select stapp-part-overlay" data-cat="' + cat + '" aria-label="Change ' + LABELS[cat] + '">' + options + '</select>' +
        '</div>'
      );
    }).join('');

    var titleMap = { amd: 'AMD Build', intel: 'Intel Build' };
    var overNote = build.overBudget > 0
      ? '<span class="note warn">' + money(build.overBudget) + ' over budget</span>'
      : '<span class="note ok">' + money(params.budget - build.total) + ' under budget</span>';
    var flag = build.compatIssue
      ? '<p class="pcbf-build-flag">Some compatibility metafields looked incomplete for this pick — please verify socket / memory type before ordering.</p>'
      : '';

    return (
      '<div class="pcbf-build-card stapp-build-card" data-platform="' + build.platform + '">' +
        (hideHead ? '' :
          '<div class="stapp-build-head">' +
            '<h4>' + titleMap[build.platform] + '</h4>' +
            '<span class="stapp-build-sub">Compatible, matched from current stock</span>' +
          '</div>') +
        '<div class="stapp-build-total-row">' +
          '<span class="stapp-total-amount">' + money(build.total) + '</span>' + overNote +
        '</div>' +
        flag +
        renderFulfilment() +
        '<div class="stapp-parts">' + rows + '</div>' +
        renderEmi(build.total) +
        '<div class="stapp-build-actions">' +
          '<button type="button" class="stapp-btn stapp-btn-buy" data-action="buy">Add build to cart · ' + money(build.total) + '</button>' +
          '<button type="button" class="stapp-btn stapp-btn-whatsapp" data-action="whatsapp">Chat with an expert</button>' +
        '</div>' +
      '</div>'
    );
  }

  function escapeHtml(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  var STATE = { builds: [], params: null, activePlatform: null };

  var PLATFORM_TAB_LABELS = { amd: 'AMD build', intel: 'Intel build' };

  function renderAll() {
    if (!STATE.builds.length) {
      results.innerHTML = '<div class="pcbf-empty">No build could be assembled from the current catalog. Check that collections and compatibility metafields are configured.</div>';
      results.hidden = false;
      intro.hidden = true;
      return;
    }

    // One build → render it directly. Multiple builds (platform "both") →
    // a segmented AMD/Intel tab bar showing one build at a time.
    if (STATE.builds.length === 1) {
      results.innerHTML = renderBuild(STATE.builds[0], STATE.params, false);
    } else {
      if (!STATE.activePlatform || !STATE.builds.some(function (b) { return b.platform === STATE.activePlatform; })) {
        STATE.activePlatform = STATE.builds[0].platform;
      }
      var tabs = '<div class="stapp-build-tabs">' + STATE.builds.map(function (b) {
        var active = b.platform === STATE.activePlatform ? ' active' : '';
        return '<button type="button" class="stapp-build-tab' + active + '" data-platform="' + b.platform + '">' +
          (PLATFORM_TAB_LABELS[b.platform] || b.platform) + '</button>';
      }).join('') + '</div>';
      var activeBuild = STATE.builds.find(function (b) { return b.platform === STATE.activePlatform; }) || STATE.builds[0];
      results.innerHTML = tabs + renderBuild(activeBuild, STATE.params, true);
    }
    results.hidden = false;
    intro.hidden = true;
  }

  // -------------------- events --------------------
  useField.addEventListener('change', function () {
    targetField.style.display = useField.value === 'gaming' ? '' : 'none';
  });
  targetField.style.display = useField.value === 'gaming' ? '' : 'none';

  function uniqueVendors(list) {
    var seen = {}, out = [];
    list.forEach(function (p) {
      var v = (p.vendor || '').trim();
      if (v && !seen[v]) { seen[v] = true; out.push(v); }
    });
    return out.sort();
  }
  uniqueVendors(CATALOG.gpu).forEach(function (v) {
    var o = document.createElement('option'); o.value = v; o.textContent = v; gpuBrandSelect.appendChild(o);
  });
  uniqueVendors(CATALOG.monitor).forEach(function (v) {
    var o = document.createElement('option'); o.value = v; o.textContent = v; monitorBrandSelect.appendChild(o);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var fd = new FormData(form);
    var params = {
      budget: parseFloat(fd.get('budget')) || 0,
      primaryUse: fd.get('primary_use'),
      platform: fd.get('platform'),
      gamingTarget: fd.get('gaming_target'),
      gpuBrand: fd.get('gpu_brand'),
      monitorBrand: fd.get('monitor_brand'),
      includeMonitor: fd.get('include_monitor') === 'on',
      includePeripherals: fd.get('include_peripherals') === 'on'
    };
    if (!params.budget || params.budget <= 0) return;

    var platforms = params.platform === 'both' ? ['amd', 'intel'] : [params.platform];
    var builds = platforms
      .map(function (p) { return buildForPlatform(p, params); })
      .filter(Boolean);

    STATE.builds = builds;
    STATE.params = params;
    renderAll();
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // swap a component
  results.addEventListener('change', function (e) {
    var select = e.target.closest('.pcbf-part-select');
    if (!select) return;
    var card = e.target.closest('.pcbf-build-card');
    var platform = card.dataset.platform;
    var build = STATE.builds.find(function (b) { return b.platform === platform; });
    var cat = select.dataset.cat;
    var id = parseInt(select.value, 10);

    var pool = candidatesFor(cat, build, STATE.params);
    var chosen = pool.find(function (p) { return p.id === id; });
    if (!chosen) return;
    build.picks[cat] = chosen;

    // cascade: motherboard change invalidates ram if now incompatible
    if (cat === 'motherboard') {
      var ramPool = compatibleRam(chosen);
      if (build.picks.ram && !ramPool.some(function (r) { return r.id === build.picks.ram.id; })) {
        build.picks.ram = pickBest(ramPool, build.total * 0.09) || ramPool[0];
      }
    }
    // cascade: processor change invalidates motherboard/ram
    if (cat === 'processor') {
      var mbPool = compatibleMotherboards(chosen);
      if (build.picks.motherboard && !mbPool.some(function (m) { return m.id === build.picks.motherboard.id; })) {
        build.picks.motherboard = mbPool[0] || build.picks.motherboard;
      }
      var ramPool2 = compatibleRam(build.picks.motherboard);
      if (build.picks.ram && !ramPool2.some(function (r) { return r.id === build.picks.ram.id; })) {
        build.picks.ram = ramPool2[0] || build.picks.ram;
      }
    }

    build.total = total(build.picks);
    build.overBudget = build.total > STATE.params.budget ? build.total - STATE.params.budget : 0;
    renderAll();
  });

  // AMD / Intel tab switch
  results.addEventListener('click', function (e) {
    var tab = e.target.closest('.stapp-build-tab');
    if (!tab) return;
    STATE.activePlatform = tab.dataset.platform;
    renderAll();
  });

  // CTA actions
  results.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var card = e.target.closest('.pcbf-build-card');
    var platform = card.dataset.platform;
    var build = STATE.builds.find(function (b) { return b.platform === platform; });

    if (btn.dataset.action === 'whatsapp') sendToWhatsApp(build);
    if (btn.dataset.action === 'buy') buyBuild(build, btn);
  });

  function sendToWhatsApp(build) {
    var lines = [platformLabel(build.platform) + ' — requested via PC Build Finder', ''];
    Object.keys(build.picks).forEach(function (cat) {
      var p = build.picks[cat];
      if (p) lines.push(LABELS[cat] + ': ' + p.title + ' (' + money(p.price) + ')');
    });
    lines.push('', 'Total: ' + money(build.total));
    var text = encodeURIComponent(lines.join('\n'));
    var url = 'https://wa.me/' + WHATSAPP_NUMBER + (WHATSAPP_NUMBER ? '?text=' + text : '');

    // StoreToApp: window.open is blocked inside the app's WebView, so ask
    // the app to open WhatsApp externally; web behaviour is unchanged
    if (inApp()) {
      window.StoreToApp.openExternal(url).catch(function () {
        window.location.href = url;
      });
      return;
    }
    window.open(url, '_blank');
  }

  function platformLabel(p) { return p === 'amd' ? 'AMD Build' : 'Intel Build'; }

  function buyBuild(build, btn) {
    var chosen = Object.keys(build.picks)
      .map(function (cat) { return build.picks[cat]; })
      .filter(Boolean);

    // Out-of-stock guard: the app's native cart (Shopify Storefront API) does
    // not reject an unavailable variant — it silently clamps the line to
    // quantity 0. So block here and ask the customer to swap the part, rather
    // than send a line that lands in the cart at 0. (On the web, /cart/add.js
    // hard-errors on out-of-stock, which is why the two behaved differently.)
    var unavailable = chosen.filter(function (p) { return p.available === false; });
    if (unavailable.length) {
      showToast('Some parts are out of stock — replace the highlighted parts, then try again.');
      var firstOos = results.querySelector('.stapp-part--oos');
      if (firstOos && firstOos.scrollIntoView) firstOos.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var items = chosen.map(function (p) { return { id: p.variant_id, quantity: 1 }; });
    if (!items.length) return;
    var originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding to cart…';

    // StoreToApp: inside the app, the build must go to the NATIVE cart via
    // the bridge — /cart/add.js would fill the separate web-session cart
    // the customer never sees. Web behaviour below is unchanged.
    if (inApp()) {
      window.StoreToApp.cart.addLines({
        lines: items.map(function (i) { return { variantId: i.id, quantity: i.quantity }; })
      })
        .then(function () { return window.StoreToApp.cart.open(); })
        .then(function () {
          btn.disabled = false;
          btn.textContent = originalLabel;
        })
        .catch(function () {
          showToast('Could not add all items to cart — please check stock and try again.');
          btn.disabled = false;
          btn.textContent = originalLabel;
        });
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        showToast('Could not add all items to cart — please check stock and try again.');
        btn.disabled = false;
        btn.textContent = originalLabel;
      });
  }

  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'pcbf-toast stapp-toast';
    t.textContent = msg;
    // Black pill, styled inline so it never depends on pcbf.css load order.
    t.setAttribute('style', [
      'position:fixed', 'left:50%', 'bottom:24px', 'transform:translateX(-50%)',
      'max-width:88%', 'box-sizing:border-box', 'background:#101322', 'color:#fff',
      'font-size:13.5px', 'font-weight:600', 'line-height:1.45', 'text-align:center',
      'padding:13px 18px', 'border-radius:12px', 'box-shadow:0 10px 34px rgba(16,19,34,.4)',
      'z-index:99999'
    ].join(';'));
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }
})();

// (function () {
//   'use strict';

//   var root = document.getElementById('pcbf-root');
//   if (!root) return;

//   // App-tuned styles for the stacked build-result cards. Injected once so the
//   // whole redesign lives in this app copy — the shared pcbf.css is untouched.
//   // Colors inherit the store accent via --pcbf-accent (defined in pcbf.css).
//   (function injectStappStyles() {
//     if (document.getElementById('stapp-build-styles')) return;
//     var css =
//       '.stapp-build-card{background:#fff;border:1px solid #e9ecf3;border-radius:16px;padding:14px;margin-bottom:16px}' +
//       '.stapp-build-tabs{display:flex;background:#eef0f6;border-radius:12px;padding:4px;gap:4px;margin-bottom:12px}' +
//       '.stapp-build-tab{flex:1;height:38px;border:0;background:transparent;border-radius:9px;font-size:13px;font-weight:600;color:#6b7280;cursor:pointer}' +
//       '.stapp-build-tab.active{background:#fff;color:var(--pcbf-accent,#3b47e0);font-weight:700;box-shadow:0 1px 3px rgba(16,19,34,.12)}' +
//       '.stapp-build-head h4{margin:0;font-size:17px;font-weight:800;color:#101322}' +
//       '.stapp-build-sub{font-size:11.5px;color:#6b7280}' +
//       '.stapp-build-total-row{display:flex;align-items:baseline;justify-content:space-between;gap:10px;margin:8px 0 12px}' +
//       '.stapp-total-amount{font-size:22px;font-weight:800;color:#101322}' +
//       '.stapp-build-total-row .note{font-size:12px;font-weight:600}' +
//       '.stapp-build-total-row .note.ok{color:#0a8a4a}.stapp-build-total-row .note.warn{color:#c0392b}' +
//       '.stapp-parts{display:flex;flex-direction:column;gap:8px}' +
//       '.stapp-part{position:relative;display:flex;align-items:center;gap:11px;background:#fff;border:1px solid #e9ecf3;border-radius:14px;padding:11px 12px}' +
//       '.stapp-part-thumb{width:46px;height:46px;border-radius:10px;object-fit:cover;background:#f0f2f8;flex-shrink:0}' +
//       '.stapp-part-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}' +
//       '.stapp-part-cat{font-size:9.5px;font-weight:700;letter-spacing:1px;color:#8a91a0}' +
//       '.stapp-part-name{font-size:13px;font-weight:700;color:#1a2032;line-height:1.3}' +
//       '.stapp-part-change{font-size:11px;font-weight:600;color:var(--pcbf-accent,#3b47e0)}' +
//       '.stapp-part-price{font-size:13px;font-weight:800;color:#101322;white-space:nowrap}' +
//       '.stapp-part-chev{color:#c2c8d6;flex-shrink:0}' +
//       '.stapp-part-overlay{position:absolute;inset:0;width:100%;height:100%;opacity:0;border:0;margin:0;padding:0;-webkit-appearance:none;appearance:none;cursor:pointer}' +
//       '.stapp-build-actions{display:flex;flex-direction:column;gap:9px;margin-top:14px}' +
//       '.stapp-btn{width:100%;border:0;border-radius:13px;font-size:15px;font-weight:700;padding:15px 12px;cursor:pointer}' +
//       '.stapp-btn-buy{background:var(--pcbf-accent,#3b47e0);color:#fff}' +
//       '.stapp-btn-whatsapp{background:#fff;color:#3a4152;border:1.5px solid #e1e5ef;font-size:13.5px;padding:12px}';
//     var el = document.createElement('style');
//     el.id = 'stapp-build-styles';
//     el.textContent = css;
//     document.head.appendChild(el);
//   })();

//   var CATALOG = JSON.parse(document.getElementById('pcbf-catalog').textContent);
//   var WHATSAPP_NUMBER = root.dataset.whatsapp || '';
//   var CURRENCY = root.dataset.currency || '₹';

//   var PICKUP_ENABLED = root.dataset.pickupEnabled === 'true';
//   var PICKUP_MESSAGE = root.dataset.pickupMessage || '';
//   var DELIVERY_MESSAGE = root.dataset.deliveryMessage || '';

//   var EMI_ENABLED = root.dataset.emiEnabled === 'true';
//   var EMI_NO_COST_TENURES = (root.dataset.emiNoCostTenures || '')
//     .split(',').map(function (s) { return parseInt(s.trim(), 10); }).filter(Boolean);
//   var EMI_INTEREST_TENURES = (root.dataset.emiInterestTenures || '')
//     .split(',').map(function (s) { return parseInt(s.trim(), 10); }).filter(Boolean);
//   var EMI_ANNUAL_RATE = parseFloat(root.dataset.emiInterestRate) || 0;

//   var form = document.getElementById('pcbf-form');
//   var useField = document.getElementById('pcbf-use');
//   var targetField = document.getElementById('pcbf-target-field');
//   var gpuBrandSelect = document.getElementById('pcbf-gpu-brand');
//   var monitorBrandSelect = document.getElementById('pcbf-monitor-brand');
//   var intro = document.getElementById('pcbf-intro');
//   var results = document.getElementById('pcbf-results');

//   // -------------------- weighting profiles --------------------
//   var CORE_CATEGORIES = ['processor', 'motherboard', 'ram', 'gpu', 'storage', 'psu', 'case', 'cooler'];
//   var LABELS = {
//     processor: 'Processor', motherboard: 'Motherboard', ram: 'Memory', gpu: 'Graphics card',
//     storage: 'Storage', psu: 'Power supply', case: 'Cabinet', cooler: 'CPU cooler',
//     monitor: 'Monitor', keyboard: 'Keyboard', mouse: 'Mouse', headset: 'Headset'
//   };
//   var WEIGHTS = {
//     gaming:    { gpu: .36, processor: .19, motherboard: .10, ram: .09, storage: .07, psu: .07, case: .06, cooler: .06 },
//     editing:   { processor: .28, gpu: .20, motherboard: .10, ram: .14, storage: .10, psu: .07, case: .05, cooler: .06 },
//     office:    { processor: .24, gpu: .08, motherboard: .14, ram: .14, storage: .14, psu: .10, case: .08, cooler: .08 },
//     streaming: { processor: .26, gpu: .24, motherboard: .10, ram: .12, storage: .08, psu: .08, case: .06, cooler: .06 }
//   };
//   var MONITOR_RESERVE = 0.09;
//   var PERIPHERALS_RESERVE = 0.05; // split across keyboard/mouse/headset
//   var DOWNGRADE_ORDER = ['headset', 'mouse', 'keyboard', 'monitor', 'case', 'cooler', 'storage', 'psu', 'gpu'];

//   // -------------------- helpers --------------------
//   function money(n) {
//     return CURRENCY + Math.round(n).toLocaleString('en-IN');
//   }
//   function norm(s) { return (s || '').toString().trim().toLowerCase(); }

//   // StoreToApp: true when running inside the mobile app's experience
//   // container (storetoapp.js SDK loaded and the native bridge is present)
//   function inApp() {
//     return !!(window.StoreToApp && window.StoreToApp.isApp);
//   }

//   function byVendor(list, vendor) {
//     if (!vendor) return list;
//     return list.filter(function (p) { return norm(p.vendor) === norm(vendor); });
//   }

//   function platformVendors(platform) {
//     if (platform === 'amd') return ['amd'];
//     if (platform === 'intel') return ['intel'];
//     return null; // both
//   }

//   // pick a good-fit item near target, with randomness so repeated searches
//   // using the same inputs don't always return the identical build
//   function pickBest(candidates, target) {
//     var avail = candidates.filter(function (p) { return p.available !== false; });
//     if (!avail.length) avail = candidates;
//     if (!avail.length) return null;
//     var sorted = avail.slice().sort(function (a, b) { return a.price - b.price; });
//     var ceiling = target * 1.2;
//     var inRange = sorted.filter(function (p) { return p.price <= ceiling; });
//     if (!inRange.length) return sorted[0]; // nothing fits near target — cheapest overall

//     // shortlist: candidates reasonably close to target price, so a random
//     // pick still stays sensible instead of jumping to something far cheaper
//     var floor = target * 0.65;
//     var shortlist = inRange.filter(function (p) { return p.price >= floor; });
//     if (!shortlist.length) shortlist = inRange.slice(-Math.min(3, inRange.length));
//     return shortlist[Math.floor(Math.random() * shortlist.length)];
//   }

//   function pickCheapest(candidates) {
//     var avail = candidates.filter(function (p) { return p.available !== false; });
//     if (!avail.length) avail = candidates;
//     if (!avail.length) return null;
//     return candidates.slice().sort(function (a, b) { return a.price - b.price; })[0];
//   }

//   function compatibleMotherboards(processor) {
//     if (!processor) return CATALOG.motherboard;
//     var matches = CATALOG.motherboard.filter(function (m) { return norm(m.socket) === norm(processor.socket) && norm(m.socket) !== ''; });
//     return matches.length ? matches : CATALOG.motherboard;
//   }
//   function compatibleRam(motherboard) {
//     if (!motherboard) return CATALOG.ram;
//     var matches = CATALOG.ram.filter(function (r) { return norm(r.memory_type) === norm(motherboard.memory_type) && norm(r.memory_type) !== ''; });
//     return matches.length ? matches : CATALOG.ram;
//   }

//   // -------------------- core build assembly --------------------
//   function buildForPlatform(platform, params) {
//     var vendors = platformVendors(platform);
//     var cpuPool = vendors ? byVendor(CATALOG.processor, vendors[0]) : CATALOG.processor;
//     if (!cpuPool.length) return null;

//     var weights = WEIGHTS[params.primaryUse] || WEIGHTS.gaming;
//     var peripheralsReserve = 0;
//     if (params.includeMonitor) peripheralsReserve += MONITOR_RESERVE;
//     if (params.includePeripherals) peripheralsReserve += PERIPHERALS_RESERVE;
//     var coreBudget = params.budget * (1 - peripheralsReserve);

//     var picks = {};
//     var compatIssue = false;

//     // processor
//     picks.processor = pickBest(cpuPool, coreBudget * weights.processor);
//     // motherboard (compat-filtered)
//     var mbPool = compatibleMotherboards(picks.processor);
//     if (picks.processor && mbPool === CATALOG.motherboard && CATALOG.motherboard.length) compatIssue = true;
//     picks.motherboard = pickBest(mbPool, coreBudget * weights.motherboard);
//     // ram (compat-filtered against motherboard)
//     var ramPool = compatibleRam(picks.motherboard);
//     if (picks.motherboard && ramPool === CATALOG.ram && CATALOG.ram.length) compatIssue = true;
//     picks.ram = pickBest(ramPool, coreBudget * weights.ram);

//     // independent categories
//     var gpuPool = byVendor(CATALOG.gpu, params.gpuBrand);
//     picks.gpu = pickBest(gpuPool.length ? gpuPool : CATALOG.gpu, coreBudget * weights.gpu);
//     picks.storage = pickBest(CATALOG.storage, coreBudget * weights.storage);
//     picks.psu = pickBest(CATALOG.psu, coreBudget * weights.psu);
//     picks.case = pickBest(CATALOG.case, coreBudget * weights.case);
//     picks.cooler = pickBest(CATALOG.cooler, coreBudget * weights.cooler);

//     if (params.includeMonitor) {
//       var monPool = byVendor(CATALOG.monitor, params.monitorBrand);
//       picks.monitor = pickBest(monPool.length ? monPool : CATALOG.monitor, params.budget * MONITOR_RESERVE);
//     }
//     if (params.includePeripherals) {
//       picks.keyboard = pickBest(CATALOG.keyboard, params.budget * PERIPHERALS_RESERVE * 0.35);
//       picks.mouse = pickBest(CATALOG.mouse, params.budget * PERIPHERALS_RESERVE * 0.30);
//       picks.headset = pickBest(CATALOG.headset, params.budget * PERIPHERALS_RESERVE * 0.35);
//     }

//     // downgrade loop over independent, non-compatibility-locked categories
//     var guard = 0;
//     while (total(picks) > params.budget && guard < 40) {
//       guard++;
//       var downgraded = false;
//       for (var i = 0; i < DOWNGRADE_ORDER.length; i++) {
//         var cat = DOWNGRADE_ORDER[i];
//         var current = picks[cat];
//         if (!current) continue;
//         var pool = poolFor(cat, params);
//         var cheaper = pool.filter(function (p) { return p.price < current.price; })
//                           .sort(function (a, b) { return b.price - a.price; })[0];
//         if (cheaper) { picks[cat] = cheaper; downgraded = true; break; }
//       }
//       if (!downgraded) break;
//     }

//     var finalTotal = total(picks);
//     return {
//       platform: platform,
//       picks: picks,
//       total: finalTotal,
//       overBudget: finalTotal > params.budget ? finalTotal - params.budget : 0,
//       compatIssue: compatIssue
//     };
//   }

//   function poolFor(cat, params) {
//     switch (cat) {
//       case 'gpu': var g = byVendor(CATALOG.gpu, params.gpuBrand); return g.length ? g : CATALOG.gpu;
//       case 'storage': return CATALOG.storage;
//       case 'psu': return CATALOG.psu;
//       case 'case': return CATALOG.case;
//       case 'cooler': return CATALOG.cooler;
//       case 'monitor': var m = byVendor(CATALOG.monitor, params.monitorBrand); return m.length ? m : CATALOG.monitor;
//       case 'keyboard': return CATALOG.keyboard;
//       case 'mouse': return CATALOG.mouse;
//       case 'headset': return CATALOG.headset;
//       default: return [];
//     }
//   }

//   // -------------------- EMI --------------------
//   function noCostEmi(amount, months) {
//     return amount / months;
//   }
//   function interestEmi(amount, months, annualRatePercent) {
//     var r = (annualRatePercent / 100) / 12;
//     if (r === 0) return amount / months;
//     var factor = Math.pow(1 + r, months);
//     var monthly = amount * r * factor / (factor - 1);
//     return monthly;
//   }
//   function emiRows(amount) {
//     var rows = [];
//     EMI_NO_COST_TENURES.forEach(function (m) {
//       rows.push({ months: m, monthly: noCostEmi(amount, m), noCost: true });
//     });
//     EMI_INTEREST_TENURES.forEach(function (m) {
//       var monthly = interestEmi(amount, m, EMI_ANNUAL_RATE);
//       var totalInterest = (monthly * m) - amount;
//       rows.push({ months: m, monthly: monthly, noCost: false, extraInterest: totalInterest });
//     });
//     rows.sort(function (a, b) { return a.months - b.months; });
//     return rows;
//   }
//   function renderEmi(amount) {
//     if (!EMI_ENABLED || amount <= 0) return '';
//     var rows = emiRows(amount);
//     if (!rows.length) return '';
//     var body = rows.map(function (row) {
//       var tag = row.noCost
//         ? '<span class="pcbf-emi-tag">No cost</span>'
//         : '<span class="pcbf-emi-tag interest">+' + money(row.extraInterest) + ' interest</span>';
//       return (
//         '<tr><td>' + row.months + ' months</td>' +
//         '<td>' + money(row.monthly) + '/mo</td>' +
//         '<td>' + tag + '</td></tr>'
//       );
//     }).join('');
//     return (
//       '<details class="pcbf-emi">' +
//         '<summary>EMI options from ' + money(rows[0].monthly) + '/mo</summary>' +
//         '<table class="pcbf-emi-table"><thead><tr><th>Tenure</th><th>Monthly</th><th></th></tr></thead>' +
//         '<tbody>' + body + '</tbody></table>' +
//         '<p class="pcbf-emi-note">Indicative figures — final EMI terms depend on your bank/card issuer.</p>' +
//       '</details>'
//     );
//   }

//   function renderFulfilment() {
//     if (!PICKUP_ENABLED) return '';
//     var parts = [];
//     if (PICKUP_MESSAGE) parts.push('<span>🏬 ' + escapeHtml(PICKUP_MESSAGE) + '</span>');
//     if (DELIVERY_MESSAGE) parts.push('<span>🚚 ' + escapeHtml(DELIVERY_MESSAGE) + '</span>');
//     if (!parts.length) return '';
//     return '<div class="pcbf-fulfilment">' + parts.join('') + '</div>';
//   }

//   function total(picks) {
//     var sum = 0;
//     Object.keys(picks).forEach(function (k) {
//       if (picks[k]) sum += parseFloat(picks[k].price) || 0;
//     });
//     return sum;
//   }

//   // -------------------- rendering --------------------
//   function candidatesFor(cat, build, params) {
//     if (cat === 'processor') {
//       var vendors = platformVendors(build.platform);
//       var pool = vendors ? byVendor(CATALOG.processor, vendors[0]) : CATALOG.processor;
//       return pool.length ? pool : CATALOG.processor;
//     }
//     if (cat === 'motherboard') return compatibleMotherboards(build.picks.processor);
//     if (cat === 'ram') return compatibleRam(build.picks.motherboard);
//     return poolFor(cat, params);
//   }

//   function renderBuild(build, params, hideHead) {
//     var order = CORE_CATEGORIES.slice();
//     if (params.includeMonitor) order.push('monitor');
//     if (params.includePeripherals) order.push('keyboard', 'mouse', 'headset');

//     // App-tuned layout: one stacked card per part instead of a 3-column table
//     // (the table crushed the part name + swap control to ~23px on a phone).
//     // Each card keeps the original <select class="pcbf-part-select"> as a
//     // transparent full-card overlay, so the existing swap listener is unchanged.
//     var rows = order.map(function (cat) {
//       var pick = build.picks[cat];
//       if (!pick) return '';
//       var cands = candidatesFor(cat, build, params).slice().sort(function (a, b) { return a.price - b.price; });
//       var options = cands.map(function (c) {
//         var sel = c.id === pick.id ? ' selected' : '';
//         return '<option value="' + c.id + '"' + sel + '>' + escapeHtml(c.title) + ' — ' + money(c.price) + '</option>';
//       }).join('');
//       var thumb = pick.image
//         ? '<img class="stapp-part-thumb" src="' + pick.image + '" alt="">'
//         : '<div class="stapp-part-thumb stapp-part-thumb--ph"></div>';
//       return (
//         '<div class="stapp-part" data-cat="' + cat + '">' +
//           thumb +
//           '<div class="stapp-part-main">' +
//             '<span class="stapp-part-cat">' + LABELS[cat] + '</span>' +
//             '<span class="stapp-part-name">' + escapeHtml(pick.title) + '</span>' +
//             '<span class="stapp-part-change">Tap to change</span>' +
//           '</div>' +
//           '<span class="stapp-part-price">' + money(pick.price) + '</span>' +
//           '<svg class="stapp-part-chev" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"></path></svg>' +
//           '<select class="pcbf-part-select stapp-part-overlay" data-cat="' + cat + '" aria-label="Change ' + LABELS[cat] + '">' + options + '</select>' +
//         '</div>'
//       );
//     }).join('');

//     var titleMap = { amd: 'AMD Build', intel: 'Intel Build' };
//     var overNote = build.overBudget > 0
//       ? '<span class="note warn">' + money(build.overBudget) + ' over budget</span>'
//       : '<span class="note ok">' + money(params.budget - build.total) + ' under budget</span>';
//     var flag = build.compatIssue
//       ? '<p class="pcbf-build-flag">Some compatibility metafields looked incomplete for this pick — please verify socket / memory type before ordering.</p>'
//       : '';

//     return (
//       '<div class="pcbf-build-card stapp-build-card" data-platform="' + build.platform + '">' +
//         (hideHead ? '' :
//           '<div class="stapp-build-head">' +
//             '<h4>' + titleMap[build.platform] + '</h4>' +
//             '<span class="stapp-build-sub">Compatible, matched from current stock</span>' +
//           '</div>') +
//         '<div class="stapp-build-total-row">' +
//           '<span class="stapp-total-amount">' + money(build.total) + '</span>' + overNote +
//         '</div>' +
//         flag +
//         renderFulfilment() +
//         '<div class="stapp-parts">' + rows + '</div>' +
//         renderEmi(build.total) +
//         '<div class="stapp-build-actions">' +
//           '<button type="button" class="stapp-btn stapp-btn-buy" data-action="buy">Add build to cart · ' + money(build.total) + '</button>' +
//           '<button type="button" class="stapp-btn stapp-btn-whatsapp" data-action="whatsapp">Chat with an expert</button>' +
//         '</div>' +
//       '</div>'
//     );
//   }

//   function escapeHtml(s) {
//     return (s || '').replace(/[&<>"]/g, function (c) {
//       return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
//     });
//   }

//   var STATE = { builds: [], params: null, activePlatform: null };

//   var PLATFORM_TAB_LABELS = { amd: 'AMD build', intel: 'Intel build' };

//   function renderAll() {
//     if (!STATE.builds.length) {
//       results.innerHTML = '<div class="pcbf-empty">No build could be assembled from the current catalog. Check that collections and compatibility metafields are configured.</div>';
//       results.hidden = false;
//       intro.hidden = true;
//       return;
//     }

//     // One build → render it directly. Multiple builds (platform "both") →
//     // a segmented AMD/Intel tab bar showing one build at a time.
//     if (STATE.builds.length === 1) {
//       results.innerHTML = renderBuild(STATE.builds[0], STATE.params, false);
//     } else {
//       if (!STATE.activePlatform || !STATE.builds.some(function (b) { return b.platform === STATE.activePlatform; })) {
//         STATE.activePlatform = STATE.builds[0].platform;
//       }
//       var tabs = '<div class="stapp-build-tabs">' + STATE.builds.map(function (b) {
//         var active = b.platform === STATE.activePlatform ? ' active' : '';
//         return '<button type="button" class="stapp-build-tab' + active + '" data-platform="' + b.platform + '">' +
//           (PLATFORM_TAB_LABELS[b.platform] || b.platform) + '</button>';
//       }).join('') + '</div>';
//       var activeBuild = STATE.builds.find(function (b) { return b.platform === STATE.activePlatform; }) || STATE.builds[0];
//       results.innerHTML = tabs + renderBuild(activeBuild, STATE.params, true);
//     }
//     results.hidden = false;
//     intro.hidden = true;
//   }

//   // -------------------- events --------------------
//   useField.addEventListener('change', function () {
//     targetField.style.display = useField.value === 'gaming' ? '' : 'none';
//   });
//   targetField.style.display = useField.value === 'gaming' ? '' : 'none';

//   function uniqueVendors(list) {
//     var seen = {}, out = [];
//     list.forEach(function (p) {
//       var v = (p.vendor || '').trim();
//       if (v && !seen[v]) { seen[v] = true; out.push(v); }
//     });
//     return out.sort();
//   }
//   uniqueVendors(CATALOG.gpu).forEach(function (v) {
//     var o = document.createElement('option'); o.value = v; o.textContent = v; gpuBrandSelect.appendChild(o);
//   });
//   uniqueVendors(CATALOG.monitor).forEach(function (v) {
//     var o = document.createElement('option'); o.value = v; o.textContent = v; monitorBrandSelect.appendChild(o);
//   });

//   form.addEventListener('submit', function (e) {
//     e.preventDefault();
//     var fd = new FormData(form);
//     var params = {
//       budget: parseFloat(fd.get('budget')) || 0,
//       primaryUse: fd.get('primary_use'),
//       platform: fd.get('platform'),
//       gamingTarget: fd.get('gaming_target'),
//       gpuBrand: fd.get('gpu_brand'),
//       monitorBrand: fd.get('monitor_brand'),
//       includeMonitor: fd.get('include_monitor') === 'on',
//       includePeripherals: fd.get('include_peripherals') === 'on'
//     };
//     if (!params.budget || params.budget <= 0) return;

//     var platforms = params.platform === 'both' ? ['amd', 'intel'] : [params.platform];
//     var builds = platforms
//       .map(function (p) { return buildForPlatform(p, params); })
//       .filter(Boolean);

//     STATE.builds = builds;
//     STATE.params = params;
//     renderAll();
//     results.scrollIntoView({ behavior: 'smooth', block: 'start' });
//   });

//   // swap a component
//   results.addEventListener('change', function (e) {
//     var select = e.target.closest('.pcbf-part-select');
//     if (!select) return;
//     var card = e.target.closest('.pcbf-build-card');
//     var platform = card.dataset.platform;
//     var build = STATE.builds.find(function (b) { return b.platform === platform; });
//     var cat = select.dataset.cat;
//     var id = parseInt(select.value, 10);

//     var pool = candidatesFor(cat, build, STATE.params);
//     var chosen = pool.find(function (p) { return p.id === id; });
//     if (!chosen) return;
//     build.picks[cat] = chosen;

//     // cascade: motherboard change invalidates ram if now incompatible
//     if (cat === 'motherboard') {
//       var ramPool = compatibleRam(chosen);
//       if (build.picks.ram && !ramPool.some(function (r) { return r.id === build.picks.ram.id; })) {
//         build.picks.ram = pickBest(ramPool, build.total * 0.09) || ramPool[0];
//       }
//     }
//     // cascade: processor change invalidates motherboard/ram
//     if (cat === 'processor') {
//       var mbPool = compatibleMotherboards(chosen);
//       if (build.picks.motherboard && !mbPool.some(function (m) { return m.id === build.picks.motherboard.id; })) {
//         build.picks.motherboard = mbPool[0] || build.picks.motherboard;
//       }
//       var ramPool2 = compatibleRam(build.picks.motherboard);
//       if (build.picks.ram && !ramPool2.some(function (r) { return r.id === build.picks.ram.id; })) {
//         build.picks.ram = ramPool2[0] || build.picks.ram;
//       }
//     }

//     build.total = total(build.picks);
//     build.overBudget = build.total > STATE.params.budget ? build.total - STATE.params.budget : 0;
//     renderAll();
//   });

//   // AMD / Intel tab switch
//   results.addEventListener('click', function (e) {
//     var tab = e.target.closest('.stapp-build-tab');
//     if (!tab) return;
//     STATE.activePlatform = tab.dataset.platform;
//     renderAll();
//   });

//   // CTA actions
//   results.addEventListener('click', function (e) {
//     var btn = e.target.closest('[data-action]');
//     if (!btn) return;
//     var card = e.target.closest('.pcbf-build-card');
//     var platform = card.dataset.platform;
//     var build = STATE.builds.find(function (b) { return b.platform === platform; });

//     if (btn.dataset.action === 'whatsapp') sendToWhatsApp(build);
//     if (btn.dataset.action === 'buy') buyBuild(build, btn);
//   });

//   function sendToWhatsApp(build) {
//     var lines = [platformLabel(build.platform) + ' — requested via PC Build Finder', ''];
//     Object.keys(build.picks).forEach(function (cat) {
//       var p = build.picks[cat];
//       if (p) lines.push(LABELS[cat] + ': ' + p.title + ' (' + money(p.price) + ')');
//     });
//     lines.push('', 'Total: ' + money(build.total));
//     var text = encodeURIComponent(lines.join('\n'));
//     var url = 'https://wa.me/' + WHATSAPP_NUMBER + (WHATSAPP_NUMBER ? '?text=' + text : '');

//     // StoreToApp: window.open is blocked inside the app's WebView, so ask
//     // the app to open WhatsApp externally; web behaviour is unchanged
//     if (inApp()) {
//       window.StoreToApp.openExternal(url).catch(function () {
//         window.location.href = url;
//       });
//       return;
//     }
//     window.open(url, '_blank');
//   }

//   function platformLabel(p) { return p === 'amd' ? 'AMD Build' : 'Intel Build'; }

//   function buyBuild(build, btn) {
//     var items = Object.keys(build.picks)
//       .map(function (cat) { return build.picks[cat]; })
//       .filter(Boolean)
//       .map(function (p) { return { id: p.variant_id, quantity: 1 }; });

//     if (!items.length) return;
//     var originalLabel = btn.textContent;
//     btn.disabled = true;
//     btn.textContent = 'Adding to cart…';

//     // StoreToApp: inside the app, the build must go to the NATIVE cart via
//     // the bridge — /cart/add.js would fill the separate web-session cart
//     // the customer never sees. Web behaviour below is unchanged.
//     if (inApp()) {
//       window.StoreToApp.cart.addLines({
//         lines: items.map(function (i) { return { variantId: i.id, quantity: i.quantity }; })
//       })
//         .then(function () { return window.StoreToApp.cart.open(); })
//         .then(function () {
//           btn.disabled = false;
//           btn.textContent = originalLabel;
//         })
//         .catch(function () {
//           showToast('Could not add all items to cart — please check stock and try again.');
//           btn.disabled = false;
//           btn.textContent = originalLabel;
//         });
//       return;
//     }

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ items: items })
//     })
//       .then(function (res) {
//         if (!res.ok) throw new Error('Cart add failed');
//         return res.json();
//       })
//       .then(function () { window.location.href = '/cart'; })
//       .catch(function () {
//         showToast('Could not add all items to cart — please check stock and try again.');
//         btn.disabled = false;
//         btn.textContent = originalLabel;
//       });
//   }

//   function showToast(msg) {
//     var t = document.createElement('div');
//     t.className = 'pcbf-toast';
//     t.textContent = msg;
//     document.body.appendChild(t);
//     setTimeout(function () { t.remove(); }, 4000);
//   }
// })();